export default {
  list: {
    header: {
      notes: 'Header in list parts pange',
      message: 'Parts',
    },
  },
  model: {
    id: {
      notes: 'Name of field "id" for articles',
      message: 'SAM Id',
    },
    displayName: {
      notes: 'Name of field "display name" for articles',
      message: 'Name',
    },
    articleNumber: {
      notes: 'Name of field "article number" for articles',
      message: 'Article #',
      invalid: {
        notes: 'Validation message for invalid article / part / item number',
        message: 'Invalid article number',
      },
    },
    weight: {
      notes: 'Name of field "weight" for articles',
      message: 'Weight',
    },
    price: {
      notes: 'Name of field "Net price" for articles',
      message: 'Net price',
    },
    listPrice: {
      notes: 'Name of field "List price" for articles',
      message: 'List price',
    },
    availability: {
      notes: 'Name of field "availability" for articles',
      message: 'Availability',
    },
    deliveryDate: {
      notes: 'Name of field "Estimated delivery date" for articles',
      message: 'Estimated delivery date',
    },
    stockStandard: {
      notes: 'Name of field "Stock standard" for articles',
      message: 'Stock standard',
    },
    description: {
      notes: 'Description of field "description" for articles',
      message: 'Description',
    },
  },
};
